import { type File } from '@littlebird/sdk';
import { createContext, useContext } from 'react';

import { filePreviewPanelStore } from './file-preview-panel.store';

export const FilePreviewHostContext = createContext<string | null>(null);

export type OpenFilePreview = (file: File) => void;

export const useOpenFilePreview = (): OpenFilePreview | undefined => {
  const hostChatId = useContext(FilePreviewHostContext);
  if (!hostChatId) return undefined;
  return (file: File) => filePreviewPanelStore.open(hostChatId, file.id);
};
